import {
  compareDatePart,
  tryDateStringToDate,
} from '../../../../../../../Utils/dateUtils';
import { NEWLY_ADDED_ID_PREFIX_FOR_UPDATE } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Const/BusinessDataFormConst';
import shortid from 'shortid';
import { ResursItem } from './PlaneringTypes';

export const isPastDate = (
  dateStr: string | null,
  today: Date = new Date()
): boolean => {
  if (!dateStr) return false;
  const normalized = dateStr.replace(/-/g, '');
  const date = tryDateStringToDate(normalized);
  if (!date) return false;
  return compareDatePart(date, today) < 0;
};

export const getResursNamn = (r: ResursItem): string | null => {
  if ('Bastyp' in r && r.Bastyp !== 'Person') return null;
  return r._Associations?.Resurs?.BO_RESURS_NAMN ?? r.RESURS_NAMN ?? null;
};

export const createEmptyPlaceholderRow = () => ({
  id: `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}${shortid.generate()}`,
  _version: null,
  FRANDATUM: '',
  FRANTID: '',
  TILLDATUM: '',
  TILLTID: '',
  AKTIVITETSTYP: '',
  VERKSAMHETSTYP_ID: '',
  GUDSTJANSTTYP_ID: '',
  TITEL: '',
  _verksamhetstypNamn: null,
  _gudstjanstTypNamn: null,
  _verksamhetstypId: null,
  _gudstjanstTypId: null,
  _selectedAssocName: null,
  isEmptyPlaceholder: true,
});

export const mapAktivitetstypCode = (obj: {
  [x: string]: any;
  AKTIVITETSTYP?: any;
}) => {
  const map: Record<string, string> = {
    Ö: 'Övrigt',
    U: 'Gudstjänst',
    D: 'Dop',
    B: 'Begravning',
    V: 'Vigsel',
    K: 'Konfirmation',
    G: 'Gravsättning',
    L: 'Lokaluthyrning',
    S: 'Snabbokning',
    AKTOVRIGT: 'Övrigt',
    GUDSTJANST: 'Gudstjänst',
    DOP: 'Dop',
    BEGRAVNING: 'Begravning',
    VIGSEL: 'Vigsel',
    KONFIRMATION: 'Konfirmation',
    GRAVSATTNING: 'Gravsättning',
    LOKALUTHYRNING: 'Lokaluthyrning',
    SNABBOKNING: 'Snabbokning',
  };
  return {
    ...obj,
    AKTIVITETSTYP: map[obj.AKTIVITETSTYP] ?? '',
  };
};
